export const ieeeTextList = [
  'ieee-access',
  'ieee-communications-letters',
  'ieee-communications-magazine',
  'ieee-control-systems',
  'ieee-design-and-test',
  'ieee-electrification-magazine',
  'ieee-intelligent-systems',
  'ieee-internet-computing',
  'ieee-magnetics-letters',
  'ieee-micro',
  'ieee-microwave-magazine',
  'ieee-multimedia',
  'ieee-network',
  'ieee-pervasive-computing',
  'ieee-photonics-journal',
  'ieee-photonics-technology-letters',
  'ieee-potentials',
  'ieee-pulse',
  'ieee-security-and-privacy',
  'ieee-software',
  'ieee-spectrum',
  'ieee-systems-journal',
  'ieee-transactions-on-automatic-control',
  'ieee-transactions-on-computational-intelligence-and-ai-in-games',
  'ieee-transactions-on-education',
  'ieee-transactions-on-learning-technologies',
  'proceedings-of-the-ieee',
]

const splitStyle = (style: string): string => {
  const styleSets = style.split('-')

  // Separate ieee from the string value
  const formattedStyles = styleSets.slice(1)

  // join the sylesets with a space
  return formattedStyles.join(' ')
}

export const ieeeStyleTextDesc = (style: string): string => {
  let formattedStyle
  if (style !== 'proceedings-of-the-ieee') formattedStyle = splitStyle(style)
  else formattedStyle = 'proceedings'
  return `Use our free ${formattedStyle} citation generator to generate IEEE-style references and citations. No more learning rules; just trust the tool for accurate citations.`
}
